import { Form, Formik } from 'formik';
import { ReactNode } from 'react';

type Props<T> = {
  initialValues: T;
  validationSchema: any;
  className?: string;
  children?: ReactNode;
  onSubmit: Function;
};

export default function HForm<T>(props: Props<T>) {
  return (
    <Formik
      initialValues={props.initialValues}
      validationSchema={props.validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        await props.onSubmit(values, setSubmitting);
      }}
    >
      <Form className={props.className || ''}>{props.children}</Form>
    </Formik>
  );
}
